import { ReactElement } from 'react';

export interface ParsedFixture {
  row: string;
  rowNumber: number;
  fixtureType: string;
  columnNumber: number;
}

export interface MacroData {
  zoneName: string;
  fixtureIds: ParsedFixture[];
  zoneId: string;
  unParsedFixtureIds: string[];
  subcategoryIds: string[];
  subcategoryNames: string[];
  concatnatedSubcategoryName: string;
  isDraft?: boolean | null;
  startTime: string;
}

export interface MacroAsinFacingData {
  zoneName: string | null | undefined;
  fixtureIds: string[] | null | undefined;
  asin: string;
  facings: number;
}

export const zoneColors: Record<string, string> = {
  Banana: '#f4d03f',
  Melons: '#e5c466',
  Tropical: '#49de6c ',
  'Potatoes & Yams': '#7e5109 ',
  Garlic: '#c4a3d1',
  Onions: '#bb8fce',
  Pears: '#fcf3cf ',
  Apples: '#e74c3c',
  Citrus: '#f39c12',
  Tomato: '#c0392b',
  Avocados: '#196f3d',
  Squash: '#f1C40f',
};

export interface FixtureComponentProps {
  fixtureIdLabel: string;
  labelOnTopOfFixture: boolean;
}

export interface FixtureComponent extends ReactElement {
  props: FixtureComponentProps;
}

export interface AsinFacingData {
  storeId: string;
  asin: string;
  fixtureId: string;
  facings: number;
}

export interface ZoneCreationProperties {
  zoneIdx: number;
  zoneName: string;
  productGroup: string;
  categoryId: string;
  subcategoryIds: string[];
  subcategoryNames: string[];
  fixtureIds: string[];
  fixtureModels?: Map<string, string>;
  facings: number;
}

export enum SwitchButtonValue {
  ViewZoneMap = 'View Zone Map',
  CreateZoneMap = 'Create Zone Map',
  CopyToNewMap = 'Copy To New Map',
}
